export const sealValidator = {
  async: false,
  validate: function(data: any) {
    const { routes, ...route_item } = data.original

    // if (!route_item.installed_location)
    const route = routes.find((el: any) => el.id == route_item.route_id)

    if (route?.subProcess?.process_type == "T") {
      // Caso n tenha campos para esse processo ignorar validações
      // Esse processo precisa do campo electromecanico
      const hasField = route.subProcess.process_fields.find((el: any) => {
        if (el.slug == "electromechanical_meter") return el
      })
      if (!hasField) return true
      if (route_item.detached) {
        if (!hasField.pivot.detached_visible) return true
      } else {
        if (!hasField.pivot.visible) return true
      }
      requiredTraditional(route_item)
      amountOfSeal(route_item, route)
      rightAndLeft(route_item)
      return true
    } else {
      // Caso n tenha campos para esse processo ignorar validações
      // Esse processo precisa do eletromecanico e do modulo cs
      const hasFields = route?.subProcess?.process_fields.filter((el: any) => {
        if (el.slug == "electromechanical_meter" || el.slug == "module_cs") {
          if (route_item.detached) {
            if (el.pivot.detached_visible) return el
          } else {
            if (el.pivot.visible) return el
          }
        }
      })
      if (!hasFields || hasFields?.length < 2) return true
      requiredElectronic(route_item)
    }
    return true
  },
}

const requiredTraditional = (data: any) => {
  if (
    (!data?.installed_location?.length || !data?.seal_series?.length) &&
    !data.justification
  )
    throw new Error(`Justifique o motivo pelo qual você não lacrou o serviço.`)
}

// amountOfSeal verifica se ele lacrou o borne e a caixa e se os valores estão dentro do permitido
const amountOfSeal = (data: any, route: any) => {
  let borne = 0
  let box = 0
  if (!data.installed_location) return true
  for (const location of data.installed_location) {
    if (location.match(/^B/g)) borne++
    if (location.match(/^C/g)) box++
  }
  if (!borne && !data.justification)
    throw new Error(
      "Você não lacrou nenhum borne! É necessário justificar o motivo."
    )
  if (borne > route.subProcess.process.borne_quantity) {
    throw new Error("Quantidade de borne está acima do limite permitido.")
  }
  if (!box && !data.justification)
    throw new Error(
      "Você não lacrou nenhuma caixa do medidor! É necessário justificar o motivo."
    )
  if (box > route.subProcess.process.meter_box_quantity) {
    throw Error(
      "Quantidade de caixa do medidor está acima do limite permitido."
    )
  }
}

// rightLeft Caso ele tenha lacrado o borne direito ele é obrigado a marcar o borne esquerdo
const rightAndLeft = (data: any) => {
  if (!data.installed_location) return
  const borne_right = data.installed_location.find((el: any) => {
    if (el == "BD") return el
  })
  const borne_left = data.installed_location.find((el: any) => {
    if (el == "BE") return el
  })
  if (!borne_left && borne_right && !data.justification)
    throw new Error(
      "É necessario justificar o motivo de não ter lacrado o borne esquerdo."
    )
  if (!borne_right && borne_left && !data.justification)
    throw new Error(
      "É necessario justificar o motivo de não ter lacrado o borne direito."
    )
}

const requiredElectronic = (data: any) => {
  if (
    data?.tli?.length > 1 ||
    data?.seal_series?.length > 1 ||
    data?.installed_location?.length > 1 ||
    data?.installed_cs_module?.length > 1
  ) {
    throw new Error("Não é permitido instalar mais de um lacre.")
  }

  if (
    !(
      ((data?.tli?.length == data?.seal_series?.length) ==
        data?.installed_location?.length) ==
      data?.installed_cs_module?.length
    ) &&
    !data.justification
  )
    if (!data.tli && !data.seal_series && !data.installed_location) {
      throw new Error(
        "Você precisa justificar o motivo de não ter instalado o lacre."
      )
    }
  if (
    data.tli &&
    (!data.seal_series || !data.installed_location) &&
    !data.justification
  ) {
    throw new Error(
      "Você precisa justificar o motivo de não ter instalado o lacre."
    )
  }
}

// const clearArray = data => {
//   if (data?.installed_location?.length && !data.installed_location[0])
//     data.installed_location = null
//   if (data?.seal_series?.length && !data.seal_series[0]) data.seal_series = null
//   if (data?.tli?.length && !data.tli[0]) data.tli = null
//   if (data?.installed_cs_module?.length && !data.installed_cs_module[0])
//     data.installed_cs_module = null
//   return data
// }
